import React, { ComponentProps, ForwardedRef, forwardRef } from 'react'

export type SvgWaterDropProps = ComponentProps<'svg'>

const SvgWaterDrop = forwardRef(
  ({ ...rest }: SvgWaterDropProps, ref: ForwardedRef<SVGSVGElement>) => {
    const dropColor = '#707683'

    return (
      <svg
        width="24"
        height="24"
        ref={ref}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 12C0 5.37258 5.37258 0 12 0V0C18.6274 0 24 5.37258 24 12V12C24 18.6274 18.6274 24 12 24V24C5.37258 24 0 18.6274 0 12V12Z"
          fill={`${dropColor}`}
        />
        <path
          d="M6.75 13.7896C6.75 11.6177 9.80156 6.97506 11.2513 4.89422C11.6182 4.36859 12.3818 4.36859 12.7487 4.89422C14.1984 6.97506 17.25 11.6177 17.25 13.7896C17.25 16.7004 14.8994 19.0385 12 19.0385C9.10057 19.0385 6.75 16.7004 6.75 13.7896ZM9.61364 13.7896C9.61364 13.5552 9.39886 13.3149 9.13636 13.3149C8.87267 13.3149 8.65909 13.5552 8.65909 13.7896C8.65909 15.653 10.1536 17.1395 12 17.1395C12.2625 17.1395 12.4773 16.9259 12.4773 16.6648C12.4773 16.4037 12.2625 16.19 12 16.19C10.6815 16.19 9.61364 15.1278 9.61364 13.7896Z"
          fill="white"
        />
      </svg>
    )
  }
)

SvgWaterDrop.displayName = 'WaterDropSvg'

export default SvgWaterDrop
